import './old/fenix4_scripts-funnel-v2'
import '@fancyapps/fancybox'
import '../styles/page-product.scss'